import axios from 'axios';
import { FILES_URL as API_URL } from '../config/api';
import { getBearer } from '../services/user';

const instance = axios.create({ baseURL: API_URL });

instance.interceptors.request.use(config => ({
  ...config,
  headers: {
    ...config.headers,
    Authorization: `Bearer ${getBearer()}`
  }
}));

export default instance;
